// @mui
import type { BoxProps } from '@mui/material';

import { Box } from '@mui/material';

const BadgeDot = ({ sx, ...other }: BoxProps) => {
  return (
    <Box
      sx={{
        bgcolor: 'error.main',
        borderRadius: '50%',
        height: 8,
        position: 'absolute',
        right: 4,
        top: 6,
        width: 8,
        ...sx,
      }}
      {...other}
    />
  );
};

export default BadgeDot;
